import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormControlComponent } from '../form/form-control.component';
import {
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownButtonItem,
  NgbDropdownItem,
} from '@ng-bootstrap/ng-bootstrap';
import { DisableDirective } from '../form/disabled.rective';
import { I18nTextPipe } from '../core/pipes/i18n-text.pipe';

@Component({
  selector: 'app-dropdown-text',
  templateUrl: './dropdown-text.component.html',
  imports: [
    FormControlComponent,
    NgbDropdown,
    NgbDropdownToggle,
    DisableDirective,
    NgbDropdownMenu,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    FormsModule,
    ReactiveFormsModule,
    I18nTextPipe,
  ],
})
export class DropdownTextComponent implements OnInit {
  @Input()
  public readonly: boolean = false;

  @Input()
  public displayDropDown: boolean = false;

  @Input()
  public labelKey: string = '';

  @Input()
  public formControlNameInput: string = '';

  @Input()
  public formArray?: FormArray;

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  public ngOnInit() {}
}
